module.exports = __webpack_public_path__ + "static/media/CA-Dragon_fireleft.45a18067.png";